import React from "react";

const ClientUserDetails: React.FC = () => {
  return (
    <div>
      {/* Client user details content goes here */}
      <h2 className="text-xl font-semibold mb-4">
        Account Details
      </h2>
      {/* Insert detail fields or child components as needed */}
      {/* Example placeholder: */}
      <div className="text-gray-700">
        This is where your account information appears.
      </div>
    </div>
  );
};

export default ClientUserDetails;
